export default "__VITE_ASSET__71e459f2__"